import React, { useRef, useEffect } from "react";
import axios from "axios";
import { loginRequest, msalInstance } from "./authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useClientAccessContext } from "../ClientAccessContext";

interface RequestInterceptorProps {
  children: React.ReactNode;
}

const getToken = async () => {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
  }

  const response: any = await msalInstance
    .acquireTokenSilent({
      account: account,
      ...loginRequest,
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        const request = {
          ...loginRequest,
          account: account,
        };
        return msalInstance.acquireTokenRedirect(request);
      }
    });

  return response.accessToken;
};

const RequestInterceptor: React.FC<RequestInterceptorProps> = ({ children }) => {
  const { selectedClient } = useClientAccessContext();
  const selectedClientRef = useRef(selectedClient);

  useEffect(() => {
    selectedClientRef.current = selectedClient;
  }, [selectedClient]);

  axios.interceptors.request.use(async (config) => {
    const bearer = `Bearer ${await getToken()}`;
    config.headers.Authorization = bearer;
    if (selectedClientRef.current) {
      config.headers["X-Client-Id"] = selectedClientRef.current.clientId;
    }
    return config;
  });

  return <>{children}</>;
};

export default RequestInterceptor;
